export default "__VITE_ASSET__C6$iAsIK__"